export default {
  "common_network_error": "Network error",
};
